import {required} from "vuelidate/lib/validators";

export class Breed {
    constructor(initObjectParams) {
        this.id = null;
        this.name = null;
        this.species = null;
        this.speciesObject = {};
    }

    static get modelName() {
        return 'Breed'
    }

    static get validations() {
        return {
            name: { required },
            species: { required },
        }
    }

    static get validationFieldLabels() {
        return {
            name: 'Название',
            species: 'Вид',
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return 'Порода'
    }

    label() {
        return 'Порода'
    }

    static get newLabel() {
        return 'Новая порода'
    }

    objectLabel() {
        return `${this.name}`
    }

    applyData(data) {
        this.id = data['id'];
        this.name = data['name'];
        this.species = data['species'];
        this.speciesObject = data['species_object'];
    }

}